import styles from "../styles.module.css";
import { useParams } from "react-router-dom";
import OptionsTypeSurvey from "./OptionsTypeSurvey";
import RatingTypeSurvey from "./RatingTypeSurvey";
import InputTypeSurvey from "./InputTypeSurvey";

const SurveyQuestionContent = ({
  options,
  showOptions,
  question,
  showRating,
  showConditional,
}) => {
  const { id } = useParams();
  const surveyId = Number(id);

  const renderQuestionType = () => {
    if (showOptions) {
      return (
        <OptionsTypeSurvey
          options={options}
          question={question}
          surveyId={surveyId}
          showConditional={showConditional}
          showRating={showRating}
        />
      );
    }

    if (showRating) {
      return <RatingTypeSurvey showConditional={showConditional} />;
    }

    return <InputTypeSurvey showConditional={showConditional} />;
  };

  return (
    <div
      style={{ marginTop: showOptions ? 30 : 0 }}
      className={styles["survey-question-options-container"]}
    >
      {renderQuestionType()}
    </div>
  );
};

export default SurveyQuestionContent;
